import React, { useState } from 'react';
import '../../assets/styles/onboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config';
import { Link, useNavigate } from 'react-router-dom';

function Login() {
    const [form, setForm] = useState({
        username: '',
        password: '',
    });

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false); 
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true); 
    
        if (!form.email || !form.password) {
            toast.error('Email and password are required');
            setLoading(false);
            return;
        }
        try {
            const response = await fetch(`${config.apiBaseUrl}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: form.email, password: form.password }),
            });
            const result = await response.json();  
            if (response.ok) {
                toast.success(`${result.user.name} logged in successfully.`);
                localStorage.setItem('authToken', result.user.id);
                setTimeout(() => navigate('/admin'), 3000);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error('An error occurred during login');
        } finally {
            setLoading(false); 
        }
    };
    return (
        <div className="container-fluid">
            <ToastContainer />
            <div className="row">
                <div className="onboard-container col-lg-7 col-12">
                </div>
                <div className="col-lg-5  col-12 logincontainediv">
                    <form className="logincontainer">
                        <h2 className="signup-header">Login</h2>
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">
                                Enter Email
                            </label>
                            <input
                                type="email"
                                className="form-style-cls"
                                id="email"
                                name="email"
                                placeholder="Enter Email..."
                                value={form.email}
                                onChange={handleChange}
                                maxLength={50}
                                required
                            />
                        </div>
                        <div className="mb-1 password-input-container">
                            <label htmlFor="password" className="form-label">
                                Enter password
                            </label>
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                className="form-style-cls"
                                id="password"
                                name="password"
                                placeholder="Test@123"
                                value={form.password}
                                onChange={handleChange}
                                required
                            />
                            <span className="confirm-password-toggle" onClick={togglePasswordVisibility}>
                                <FontAwesomeIcon
                                    className="eyepassword"
                                    icon={passwordVisible ? faEyeSlash : faEye}
                                />
                            </span>
                        </div>
                        <div className="forgot-pwd d-flex">
                            <Link to="/sentotp">
                                <button className="btn-link-new SMN_effect-73" type="button">
                                    Forgot Password?
                                </button>
                            </Link>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary signup-btn"
                            onClick={handleLogin}
                            disabled={loading} 
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
